import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { ChannelType } from '../type';

export const MessageDisclaimer = (props: {
  channelType: ChannelType;
  readonly?: boolean;
}) => {
  const { channelType, readonly } = props;
  const intl = useIntl();

  if (
    !readonly &&
    (channelType === 'SCHEDULING_TEAM' || channelType === 'PEER_TO_PEER')
  ) {
    return null;
  }

  let messageId: string;
  if (readonly && channelType === 'PEER_TO_PEER') {
    messageId = 'community.messages.disconnected-notifier';
  } else if (readonly) {
    messageId = 'care-team.read-only.disclaimer';
  } else if (channelType === 'CARE_TEAM') {
    messageId = 'care-team.ccm.disclaimer';
  } else {
    messageId = 'care-team.provider.disclaimer';
  }

  return (
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'center',
        bgcolor: '#d6e5f9',
        p: 3.75,
        ...(readonly && { fontWeight: 'normal', fontStyle: 'italic' }),
      }}
    >
      {intl.formatMessage({ id: messageId })}
    </Typography>
  );
};
